import _ from 'lodash'

import {
  Json,
  LegacyPage,
  Modal,
  Panels,
  Bar,
  LoadingContainer,
  Breadcrumb,
} from 'peach/components'
import { getName } from 'peach/helpers'
import { useRouteMatch, useParams } from 'peach/router'
import { useCompanyId } from 'peach/scopes/company'

import { useCompanyRoleDelete, useCompanyRoleGetAll } from 'core/types'

const CompanyPermission = () => {
  const companyId = useCompanyId()
  const { url } = useRouteMatch()
  const { roleId, permissionId } = useParams()

  const { data: roles, isLoading: isLoadingRoles } = useCompanyRoleGetAll({
    companyId,
    query: { limit: 100 },
  })

  const role = _.find(roles, { id: roleId })

  const { permissions } = role || {}

  const permission = _.find(permissions, { id: permissionId })

  const { mutateAsync: deletePermission } = useCompanyRoleDelete({
    companyId,
    roleId,
  })

  const sendDeletePermission = async () => {
    await deletePermission()
  }

  return (
    <Panels
      header={
        <Bar
          right={
            <Modal
              onSubmit={sendDeletePermission}
              title='Delete Permission'
              trigger
            >
              <Json.Table json={permission} />
            </Modal>
          }
          title='Permission'
        />
      }
    >
      <Breadcrumb title={getName(permission)} to={url} />
      <LoadingContainer isLoading={isLoadingRoles}>
        <LegacyPage>
          <Json.Table json={permission} />
        </LegacyPage>
      </LoadingContainer>
    </Panels>
  )
}

export default CompanyPermission
